import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';

import { ISalesOrderFormInvoiceItem } from '../sales-order-invoice.interface';

@Component({
  selector: 'lum-create-invoice-ag-grid-table',
  standalone: true,
  imports: [CommonModule, AgGridModule],
  templateUrl: './create-invoice-ag-grid-table.component.html',
  styleUrls: ['./create-invoice-ag-grid-table.component.scss'],
})
export class CreateInvoiceAgGridTableComponent implements OnInit {
  @Input() salesOrderFormLineItems :ISalesOrderFormInvoiceItem[] = [];

  @Output() totalQuantityToInvoice = new EventEmitter<number>();

  columnDefs :ColDef[] = [
    { field: 'productName', headerName: 'Product Name', editable: false },
    { field: 'productSku', headerName: 'Product SKU', editable: false },
    {
      field: 'orderedQuantity',
      headerName: 'Ordered Quantity',
      editable: false,
      valueFormatter: (params) => `${params.value} ${params.data.orderedUnit}`,
    },
    {
      field: 'invoicedQuantity',
      headerName: 'Invoiced Quantity',
      editable: false,
      valueFormatter: (params) => `${params.value} ${params.data.orderedUnit}`,
    },
    {
      field: 'fulfilledQuantity',
      headerName: 'Fulfilled Quantity',
      editable: false,
      valueFormatter: (params) => `${params.value} ${params.data.orderedUnit}`,
    },
    {
      field: 'toInvoiceQuantity',
      headerName: 'To Invoice Quantity',
      editable: true,
      cellClass: 'highlight-cell',
      cellClassRules: {
        'invalid-quantity': (params) =>
          params.data.toInvoiceQuantity >
          params.data.orderedQuantity - params.data.invoicedQuantity,
      },
      valueSetter: (params) => {
        const newValue = params.newValue;
        const maxInvoiceQuantity =
          params.data.orderedQuantity - params.data.invoicedQuantity;

        if (newValue > maxInvoiceQuantity) {
          params.data.toInvoiceQuantity = maxInvoiceQuantity;
        } else if (newValue < 0) {
          params.data.toInvoiceQuantity = 0;
        } else {
          params.data.toInvoiceQuantity = newValue;
        }

        return true;
      },
    },
  ];

  defaultColDef :ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  gridOptions :GridOptions = {
    columnDefs: this.columnDefs,
    defaultColDef: this.defaultColDef,
    onCellValueChanged: this.onCellValueChanged.bind(this),
  };

  gridApi! :GridApi;

  constructor() {}

  ngOnInit() :void {}

  getLineItemsData() :ISalesOrderFormInvoiceItem[] {
    return this.salesOrderFormLineItems;
  }

  onGridReady(params :GridReadyEvent) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
  }

  onCellValueChanged(event :any) {
    if (event.colDef.field === 'toInvoiceQuantity') {
      const total = this.calculateTotalToInvoiceQuantity();
      this.totalQuantityToInvoice.emit(total);
    }
  }

  calculateTotalToInvoiceQuantity() :number {
    let total :number = 0;
    this.gridApi.forEachNode((rowNode) => {
      const toInvoiceQuantity = Number(rowNode.data.toInvoiceQuantity) || 0;
      total += toInvoiceQuantity;
    });

    return total;
  }
}
